"use client";

import { CallToAction, Dialog, Grid2, Typography } from "@repo/ui";
import Section from "../components/Section";
import CompanyLogoCard from "../components/CompanyLogoCard";
import { hasData } from "@/lib/helpers";
import { useEffect, useMemo, useState } from "react";
import DownloadBrochureForm from "@/components/forms/DownloadBrochureForm";
import BreadcrumbsLink from "@/components/common/BreadcrumbsLink";
import Link from "next/link";
import { deleteCookie, setCookie } from "cookies-next";

type BannerWithBackgroundImageContentType = {
  backgroundImagePath?: string;
  primaryButtonAction?: string;
  primaryButtonText?: string;
  secondaryButtonAction?: string;
  secondaryButtonText?: string;
  heading: string;
  paragraph?: string;
  breadcrumbs: BreadcrumbsType[];
  serviceId?: number;
};

type BannerWithBackgroundImageProps = {
  sectionInfo: PageSections;
  data: BannerWithBackgroundImageContentType;
};

const BannerWithBackgroundImage = (props: BannerWithBackgroundImageProps) => {
  const { data, sectionInfo } = props;
  const [open, setOpen] = useState(false);
  const hasPopup = useMemo(() => {
    return (
      data.secondaryButtonAction &&
      data.secondaryButtonAction?.endsWith("_POPUP")
    );
  }, [data]);

  useEffect(() => {
    if (data.serviceId) {
      setCookie("serviceId", data.serviceId);
    }
    return () => {
      deleteCookie("serviceId");
    };
  }, [data.serviceId]);
  if (!hasData(data)) return null;

  const {
    backgroundImagePath,
    heading,
    paragraph,
    primaryButtonAction,
    primaryButtonText,
    secondaryButtonAction,
    secondaryButtonText,
    breadcrumbs,
  } = data;

  return (
    <Section
      className={`${sectionInfo.sectionClass} bg-cover bg-no-repeat  bg-center`}
      id={sectionInfo.sectionId}
      bgImage={backgroundImagePath}
    >
      <BreadcrumbsLink breadcrumbs={breadcrumbs} />
      <Grid2 container align="center" spacing={4} className="min-h-[300px]">
        <Grid2 item xs={12} md={8} className="text-white">
          {heading && (
            <Typography
              variant="h1"
              gutterBottom
              className="!leading-snug tracking-wide !font-semi-bold"
            >
              {heading}
            </Typography>
          )}
          {paragraph && <Typography paragraph>{paragraph}</Typography>}

          <CallToAction
            size="large"
            className="my-6"
            isResponsive
            color="secondary"
            onSaveLabel={primaryButtonText}
            onSaveRender={
              <Link href={primaryButtonAction ? primaryButtonAction : "#"} />
            }
            onCancelLabel={secondaryButtonText}
            onCancel={() => {
              if (hasPopup) {
                setOpen(true);
              }
            }}
            onSaveHidden={!primaryButtonText || !primaryButtonAction}
            onCancelHidden={!secondaryButtonText || !secondaryButtonAction}
          />
        </Grid2>
      </Grid2>
      <CompanyLogoCard className="bg-white/75" />
      {/* DownloadBrochure popUp */}
      <Dialog open={open} onOpenChange={setOpen} maxWidth="md" className="!p-0">
        <DownloadBrochureForm serviceId={data?.serviceId} />
      </Dialog>
    </Section>
  );
};

export default BannerWithBackgroundImage;
